import {ContractModel} from '../../model'
import {aditionalValues} from '../../../../util/utilitario'
export const initValues: ContractModel = {
  id: '',
  gerencia: '',
  clienteId: '',
  companiaId: '',
  siteId: '',
  empresaId: '',
  tipoRecepcionador: '',
  ...aditionalValues,
}
